module.exports = __webpack_public_path__ + "static/media/escalafon.c7d52291.pdf";